import { render, staticRenderFns } from "./TableReviewSystem.vue?vue&type=template&id=9c323b78"
import script from "./TableReviewSystem.vue?vue&type=script&lang=js"
export * from "./TableReviewSystem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports